import { Product } from "./product.model";
import {Address} from "../components/AddressSelector/Address"

export class Property {
  key: string = ""; //Unique identifier for the property (Address1 + PostCode)
  address: Address = new Address();
  hmo: boolean = false;
  tenancyCount: number = 0;
  numberOfFlats: number = 0;
  startDate: string = "";
  products: Array<Product> = new Array<Product>();
}
